import VueRouter from "vue-router";

const updateDocumentTitle = (path: string, title?: string) => {
  let subtitle = "";

  if (path !== "/" && title) subtitle = `${title} - `;

  if (subtitle) document.title = `${subtitle}${process.env.VUE_APP_TITLE}`;
};

export const useTitleUpdater = (router: VueRouter) => {
  router.afterEach((to) => {
    if (to.meta?.title !== "Back") updateDocumentTitle(to.path, to.meta?.title);
  });
};
